module.exports = __webpack_public_path__ + "img/prop-star-1.7e050592.webp";